export const API_ACCESS_TOKEN_KEY = "API_ACCESS_TOKEN_KEY"